// extracted by mini-css-extract-plugin
module.exports = {"ebanner":"M-z"};